import React, { useContext, useEffect } from "react";
import { Modal } from "antd";
import { useForm } from "react-hook-form";
import { MyContext } from "../MyContext/MyProvider";
import { editProfileByAdminAPI, getProfileByAdminAPI } from "../APIs/API";

const EditUserModal = ({ isEditUserModalOpen, setisEditUserModalOpen }) => {
  const { currentUserToEdit } = useContext(MyContext);

  const handleOk = () => {
    setisEditUserModalOpen(false);
  };
  const handleCancel = () => {
    clearErrors();

    setisEditUserModalOpen(false);
  };

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const fetchData = async () => {
      if (currentUserToEdit === "") {
        return;
      }
      try {
        const res = await getProfileByAdminAPI(currentUserToEdit);
        if (res) {
          setValue("email", res.email);
          setValue("firstname", res.firstname);
          setValue("lastname", res.lastname);
          setValue("address", res.address);
          setValue("contact_number", res.contact_number);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [currentUserToEdit]);

  const onSubmit = async (data) => {
    try {
      const res = await editProfileByAdminAPI(data);
      handleOk();
    } catch (error) {
      console.error("Submit error: ", error);
    }
  };

  return (
    <>
      <Modal
        open={isEditUserModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="edituser-modal"
        centered={true}
        width="60%"
      >
        <div className="modal-content my-5">
          <h2 className="fw-bold text-medium-black text-center">Edit User</h2>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="template-div v-center h-center flex-column mt-5">
              <div className="edit-profile-main d-flex flex-column gap-5">
                <div className="edit-container d-flex space-between gap-5 ">
                  <div className="edit-profile-inner d-flex flex-column gap-3">
                    <h5>Type</h5>
                    <input
                      type="text"
                      placeholder="Type..."
                      className="modal-input "
                    ></input>
                  </div>
                  <div className="edit-profile-inner d-flex flex-column gap-3">
                    <h5>Email Address</h5>
                    <input
                      {...register("email", {
                        required: "Email is required",
                        maxLength: {
                          value: 30,
                          message: "Must not be more than 30 characters",
                        },
                        pattern: {
                          value:
                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$/,
                          message: "Invalid email address",
                        },
                      })}
                      inputMode="email"
                      disabled
                      type="email"
                      placeholder="abc@gmail.com"
                      className="modal-input"
                    />
                    {errors.email && (
                      <span className="error">{errors.email.message}</span>
                    )}
                  </div>
                </div>
                <div className="edit-container d-flex space-between gap-5 ">
                  <div className="edit-profile-inner d-flex flex-column gap-3">
                    <h5>First Name</h5>
                    <input
                      {...register("firstname", {
                        required: "First name is required",
                        maxLength: {
                          value: 20,
                          message: "Must not be more than 20 characters",
                        },
                      })}
                      inputMode="text"
                      type="text"
                      placeholder="First Name"
                      className="modal-input "
                    />{" "}
                    {errors.firstname && (
                      <span className="error">{errors.firstname.message}</span>
                    )}
                  </div>
                  <div className="edit-profile-inner d-flex flex-column gap-3">
                    <h5>Address</h5>
                    <input
                      {...register("address", {
                        required: "address is required",
                        maxLength: {
                          value: 100,
                          message: "Must not be more than 50 characters",
                        },
                      })}
                      inputMode="text"
                      type="text"
                      placeholder="Address"
                      className="modal-input "
                    />
                    {errors.address && (
                      <span className="error">{errors.address.message}</span>
                    )}
                  </div>
                </div>
                <div className="edit-container d-flex space-between gap-5 ">
                  <div className="edit-profile-inner d-flex flex-column gap-3">
                    <h5>Last Name</h5>
                    <input
                      {...register("lastname", {
                        required: "Last name is required",
                        maxLength: {
                          value: 20,
                          message: "Must not be more than 20 characters",
                        },
                      })}
                      inputMode="text"
                      type="text"
                      placeholder="Last Name"
                      className="modal-input "
                    />
                    {errors.lastname && (
                      <span className="error">{errors.lastname.message}</span>
                    )}
                  </div>
                  <div className="edit-profile-inner d-flex flex-column gap-3">
                    <h5>Contact Number</h5>
                    <input
                      {...register("contact_number", {
                        required: "Contact number is required",
                        maxLength: {
                          value: 20,
                          message: "Must not be more than 20 characters",
                        },
                        pattern: {
                          value: /^[0-9]+$/,
                          message:
                            "Invalid contact number, must only be digits",
                        },
                      })}
                      inputMode="numeric"
                      type="number"
                      placeholder="Contact Number"
                      className="modal-input "
                    />
                    {errors.contact_number && (
                      <span className="error">
                        {errors.contact_number.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="modal-bottom-btns d-flex gap-2 mt-5">
                <button
                  className="modal-dark-btn"
                  type="button"
                  onClick={handleCancel}
                >
                  Close
                </button>
                <button className="modal-dark-btn" type="submit">
                  Update
                </button>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default EditUserModal;
